<template>
  <BoardView :title="file.name" wrap="lg">
    <FormValidation @submit="save">
      <FormImage :image="file" />
      <Btn v-if="hasRole('ADMIN')" class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardSingle from '@mixins/BoardSingle'
import FormImage from './components/FormImage'

export default {
  mixins: [BoardSingle('file')],
  components: { FormImage },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Update"
  }
}
</i18n>
